export default __webpack_public_path__ + "static/media/supply-siger-group-icon-green.715a704c.svg";